module.exports = __webpack_public_path__ + "static/img/bg_mod_smarttransportation.28b3c30e.jpg";